// StripeWrapper.js
import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePayment from "./StripePayment";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../axiosinstens";
import CryptoJS from "crypto-js";

const StripeWrapper = () => {
  const [stripePromise, setStripePromise] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const seminar_data = location.state?.seminar_data;
  const settings = location.state?.settings;
  const organizer = location.state?.organizer;

  useEffect(() => {
    const initStripe = async () => {
      //---------------------------
      // 1️⃣ Decrypt JWT Token
      //---------------------------
      let decryptedToken = "";

      const encryptedToken = localStorage.getItem("tokenJwt");
      if (encryptedToken) {
        try {
          const bytes = CryptoJS.AES.decrypt(
            encryptedToken,
            "secret-key-token-seminar"
          );
          decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
          setAuthToken(decryptedToken);
        } catch (err) {
          console.error("Token decrypt error");
        }
      }

      //---------------------------
      // 2️⃣ If token missing → logout
      //---------------------------
      if (!decryptedToken) {
        localStorage.removeItem("organizer");
        localStorage.removeItem("tokenJwt");
        setIsLoggedIn(false);
        navigate("/login");
        return;
      }

      //---------------------------
      // 3️⃣ Get stripe public key (from API)
      //---------------------------
      try {
        const res = await axios.get("/getPublicKey", {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });

        if (res.data.publicKey) {
          const stripe = await loadStripe(res.data.publicKey);
          setStripePromise(stripe);
        }
      } catch (err) {
        console.error("Error loading Stripe key:", err);
        localStorage.removeItem("organizer");
        localStorage.removeItem("tokenJwt");
        setIsLoggedIn(false);
        navigate("/login");
      }
    };

    initStripe();
  }, []);

  // Wait until stripePromise is loaded
  if (!stripePromise || !authToken)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
          fontSize: "22px",
          fontWeight: "600",
        }}
      >
        Loading...
      </div>
    );

  return (
    <Elements stripe={stripePromise}>
      <StripePayment
        seminar_data={seminar_data}
        settings={settings}
        organizer={organizer}
        authToken={authToken}
      />
    </Elements>
  );
};

export default StripeWrapper;
